var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2816 20.2528C15.8272 20.2528 19.9584 14 19.9584 8.57597C19.9584 8.39997 19.9584 8.22077 19.9456 8.04477C20.7488 7.46237 21.4432 6.74557 21.9936 5.91997C21.2448 6.25277 20.4512 6.47037 19.6384 6.56637C20.496 6.05437 21.136 5.24797 21.4432 4.29757C20.6368 4.77437 19.7568 5.11357 18.8384 5.29277C17.2832 3.64157 14.6848 3.56157 13.0336 5.11357C11.968 6.11517 11.5168 7.60957 11.8464 9.03357C8.5472 8.86717 5.472 7.30877 3.3888 4.74557C2.3008 6.62077 2.8544 9.01757 4.6592 10.224C4.0064 10.2048 3.3664 10.0288 2.7968 9.71197C2.7968 9.72797 2.7968 9.74717 2.7968 9.76317C2.7968 11.7152 4.1728 13.3984 6.0896 13.7856C5.4848 13.9488 4.8512 13.9744 4.2368 13.856C4.7744 15.5264 6.3136 16.672 8.0704 16.7072C6.6176 17.8496 4.8224 18.4704 2.976 18.4672C2.6496 18.4672 2.3232 18.448 2 18.4064C3.8688 19.6128 6.0544 20.2528 8.2816 20.2496",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.760d0254e727c1e92af8e82cf46c2a51.svg";
export { ForwardRef as ReactComponent };